import classnames from 'classnames/bind'
import { animate, m, useMotionValue } from 'framer-motion'
import { useRef } from 'react'
import { GlobalThemeColors } from '~/@types/colors'

import { useMeasureObserver } from '@unlikelystudio/react-hooks'

import { NavArrowIcon } from '~/components/UI/Icons'
import Table, { TableProps } from '~/components/UI/Table'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type CustomTableProps = {
  className?: string
  table?: TableProps
}

function CustomTable({ className, ...table }: CustomTableProps) {
  const componentRef = useRef()
  const containerRef = useRef<HTMLDivElement>()

  const { width: containerWidth } = useMeasureObserver(
    containerRef,
    'getBoundingClientRect',
  )
  const { width: componentWidth } = useMeasureObserver(
    componentRef,
    'getBoundingClientRect',
  )

  const scrollX = useMotionValue(0)

  const offset = componentWidth - containerWidth

  return (
    <div className={cx(css.CustomTable, className)}>
      {offset > 0 && (
        <div className={cx(css.nav)}>
          <button
            className={css.prev}
            aria-label="nav-arrow-icon"
            onClick={() => {
              animate(
                scrollX,
                -1 *
                  (containerRef.current.scrollLeft - offset / 2 >= 0
                    ? containerRef.current.scrollLeft - offset / 2
                    : 0),
              )
            }}>
            {
              <NavArrowIcon
                className={cx(css.navIcon)}
                theme={GlobalThemeColors.Black}
              />
            }
          </button>
          <button
            className={css.next}
            aria-label="nav-arrow-icon"
            onClick={() => {
              animate(
                scrollX,
                -1 *
                  (scrollX.get() - offset / 2 > offset
                    ? scrollX.get() - offset / 2
                    : offset),
              )
            }}>
            {
              <NavArrowIcon
                className={cx(css.navIcon)}
                theme={GlobalThemeColors.Black}
              />
            }
          </button>
        </div>
      )}
      <div className={cx(css.wrapper)} ref={containerRef}>
        <m.div
          className={cx(css.tableContainer)}
          ref={componentRef}
          style={{ x: scrollX }}
          drag="x"
          dragConstraints={containerRef}>
          <Table className={cx(css.table)} {...table} />
        </m.div>
      </div>
    </div>
  )
}

export default CustomTable
